<template>
  <shit-shell title="Organize (Not Working, Yet)">
    <shit-todo :shit="shit" :selectable="false"/>
    <div class="mt-6 flex flex-col px-4 sm:px-6">
      <button @click="defer" class="my-1 border-2 border-russet bg-white text-russet font-semibold py-1 px-3 rounded shadow-md">
        Defer
      </button>
      <button @click="delegate" class="my-1 border-2 border-russet bg-white text-russet font-semibold py-1 px-3 rounded shadow-md">
        Delegate
      </button>
      <button @click="schedule" class="my-1 border-2 border-russet bg-white text-russet font-semibold py-1 px-3 rounded shadow-md">
        Schedule
      </button>
      <button @click="review" class="my-1 border-2 border-russet bg-white text-russet font-semibold py-1 px-3 rounded shadow-md">
        Someday
      </button>
      <button @click="bookmark" class="my-1 border-2 border-russet bg-white text-russet font-semibold py-1 px-3 rounded shadow-md">
        Reference
      </button>
      <button @click="trash" class="my-1 border-2 border-russet bg-white text-russet font-semibold py-1 px-3 rounded shadow-md">
        Trash
      </button>
      <!-- <select class="my-1 border-2 border-russet bg-white text-russet font-semibold py-1 px-3 rounded shadow-md" style="text-align-last: center;">
        <option v-for="option in repeatOptions" :key="option">{{ option }}</option>
      </select> -->
    </div>
  </shit-shell>
</template>

<script>
import ShitShell from '../components/ShitShell'
import ShitTodo from '../components/ShitTodo'
import shit from '../mixins/shit'
import { mapActions } from 'vuex'

export default {
  mixins: [shit],
  props: {
    uuid: {
      type: String,
      requred: true
    }
  },
  components: {
    ShitShell,
    ShitTodo
  },
  data () {
    return {
      shit: this.$store.getters.shit(this.uuid),
      action: null,
      repeatOptions: ['Repeat', 'Daily', 'Weekly', 'Monthly', 'Annually', 'Every weekday']
    }
  },
  methods: {
    ...mapActions(['syncShit']),
    defer () {

    },
    delegate () {

    },
    schedule () {

    },
    review () {

    },
    bookmark () {

    },
    trash () {

    },
    goToNextShit: function () {
      window.setTimeout(() => {
        this.open = false
        this.action = null
        // this.action = null
        // this.shitIndex = this.shitIndex + 1
        // if (this.shitIndex === this.shitTotal) {
        //   this.isFinished = true
        // } else {
        //   this.shit = this.collectedShits[this.shitIndex]
        // }
      }, 700)
    }
  }
}
</script>
